enum ApiConnectionType {
  'op' = 'op',
  'preFlight' = 'preFlight',
}

export default ApiConnectionType;
